import { createSelector } from 'reselect'
import {MOD} from './parser.js';

const getCycleLength = (cycle) => {
    let factor = cycle.cycleLength || 1;
    let sum=0;
    for (let i=0; i < cycle.length; i++) {
        let term = cycle[i];
        if (Array.isArray(term) && term.cycleLength !== undefined) {
            sum += term.cycleLength;
        } else {
            sum++;
        }
    }
    return sum; /// / factor;
};

// get the step from the step number of the cycle of
// a given length
// Returns undefined if theres nothing to play
// Otherwise it returns the transpose to play
const getDiv = (
    cycle,
    stepNumber,
    length, // the cycle length (of the current cycle)
    c=0, // counts how far into the cycle we are
    cycleNumber, // the iteration of the cycle (used for / operator),
    outputNumber=0
) => {
    // divide the cycle into cycle.length many parts each with length=div (of steps)
    let fullDiv = length / getCycleLength(cycle);
    let i = 0; 
    let triggers = [];
    for (; i < cycle.length; i++) {
        let div = fullDiv * (cycle[i].cycleLength || 1);
        if (cycle[i] !== null &&
            Array.isArray(cycle[i])) {
            if (stepNumber >= Math.floor(c) && stepNumber < c + div) { 
                getDiv(cycle[i], stepNumber, div, c, cycleNumber).forEach(
                    trigger => triggers.push(trigger));
            }
       } else if (cycle[i] && cycle[i].cycle) {
           if (stepNumber >= c && stepNumber < c + div) {
               let shouldAdd = true;
               if (cycle[i].operator === '/') {
                   shouldAdd = cycleNumber % cycle[i].operand === 0;
               }
               if (shouldAdd) {
                   let outputNumber = cycle[i].operator === "^" ? cycle[i].operand : 0;
                   getDiv(cycle[i].cycle, stepNumber, div, c, cycleNumber, outputNumber).forEach(
                       trigger => triggers.push(trigger));
               }
           }
       } else {
           if (stepNumber == Math.floor(c)) {
               let shouldAdd = true;
               if (cycle[i].operator === '/') {
                   shouldAdd = cycleNumber % cycle[i].operand === 0;
               } 
               if (shouldAdd) {
                   triggers.push({
                       ... cycle[i],
                       outputNumber: cycle[i].operator === MOD ? cycle[i].operand : outputNumber,
                       offset: c - Math.floor(c),
                       duration: div / 2,
                       cycle: cycle[i].id,
                       leaf: cycle[i]
                   });
               }
           }
       }
        let factor = cycle[i].cycleLength || 1;
        c += div;
    }
    return triggers;
};

const getCycle = state => state.cycle;
const getStepNumber = state => state.stepNumber;
const getLength = state => state.length;

// memoize so that we dont need to recalculate for
// same input
// TODO: once we have nondeterministic cycles, we
// will need to make sure the cycle is deterministic
// before using the memoized function
export const getStep = (x) =>
    getDiv(
        expandCycle(getCycle(x)),
        getStepNumber(x) % getLength(x),
        getLength(x),
        0,
        Math.floor(getStepNumber(x) / getLength(x)));

export const expandCycle = (cycle) => {
    let expanded = [];
    let {cycleLength} = cycle;
    for (let i=0; i <  cycle.length; i++) {
        if (Array.isArray(cycle[i])) {
            expanded.push(expandCycle(cycle[i]));
        } else {
            expanded = [... expanded, ...expandLeaf(cycle[i])];
        }
    }
    expanded.cycleLength = cycleLength;
    return expanded;
};

// returns a list to be concatenated onto the expanded cyccle
// if thers a star operand, it expands it
const expandLeaf = (leaf) => {
    let toExpand = undefined;
    let {operator, operand, transpose, cycle} = leaf;
    if (cycle) {
        toExpand = expandCycle(cycle);
    } else {
        toExpand = leaf;
    }

    if (operator === '*') {
        let expanded = [];
        for (let i=0; i < operand; i++) {
            expanded.push(toExpand);
        }
        return expanded;
    } else if (operator === '^') {
        let expanded = [];
        for (let i=0; i < operand; i++) {
            expanded.push({
                ... toExpand,
                factor: (i+1.0) / (operand + 1)
            });
        }
        return expanded;
    }
    return [leaf];
}


export const getLeafNumber = (cycle, leaf, cycleLength) => {
   let flattened = cycle.flat(16);

    let leafIndex = -1;
    let nextNonRest = -1;
    let firstNonRest = -1;
    for (let i=0; i < flattened.length; i++ ){
        let term = flattened[i];
        if (term.id === leaf.id) {
            return i;
        }
    }
    return -1;
};

// find next leaf
export const getLegatoDuration = (cycle, leaf, cycleLength) => {
    let flattened = cycle.flat(16);

    let leafIndex = -1;
    let nextNonRest = -1;
    let firstNonRest = -1;
    for (let i=0; i < flattened.length; i++ ){
        let term = flattened[i];
        if (firstNonRest === -1 && leaf.transpose !== null) {
            firstNonRest = i;
        }
        if (term.id === leaf.id) {
            leafIndex = i;
            continue;
        }

        if (term.transpose !== null && leafIndex !== -1) {
            // we found the next one
            nextNonRest = i;
            break;
        }
    }

    if (nextNonRest === -1) {
        return firstNonRest + flattened.length - leafIndex;
    }
    let ratio = cycleLength / cycle.length;
    let distance = nextNonRest - leafIndex;
    return distance * (ratio / 2);
};
